import { FC, useMemo } from 'react';
import './style.scss';

interface IProps {
  title: string;
  type?: 'primary' | 'tertiary';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const ItemImageButton: FC<IProps> = ({ title, type = 'tertiary', onClick, disabled = false, className = '' }: IProps): JSX.Element => {
  const buttonClassName = useMemo((): string => {
    let _className: string = 'item-images__btn';

    _className += type === 'primary' ? ' item-images__btn_primary' : ' item-images__btn_tertiary';
    if (className) _className += ` ${className}`;

    return _className;
  }, [type, className]);

  return (
    <button onClick={onClick} disabled={disabled} className={buttonClassName}>
      {title}
    </button>
  );
};

export default ItemImageButton;
